import { combineReducers } from 'redux'
import store from './store'


export default combineReducers({ store })